import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Box } from '@qga/roo-ui/components';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';
import TextButton from 'components/TextButton';
import Markup from 'components/Markup';
import Modal from 'components/Modal';

const TermsAndConditionsModal = ({ roomName, termsAndConditions }) => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();

  const openRoomDetailsModal = () => {
    openModal();
    emitInteractionEvent({ type: 'Room Details Terms and Conditions Pop Up', value: 'Link Selected' });
  };

  return (
    <Wrapper>
      <TextButton
        color="greys.dusty"
        hoverColor="greys.dusty"
        onClick={openRoomDetailsModal}
        fontSize="xs"
        aria-label={`Terms and conditions for ${roomName}`}
      >
        Terms and conditions apply
      </TextButton>

      <Modal {...modalProps} title="Terms and Conditions">
        <Box fontSize={['sm', 'base']} mb={4} data-testid="check-availability-terms-and-conditions">
          <Markup content={termsAndConditions} />
        </Box>
      </Modal>
    </Wrapper>
  );
};

TermsAndConditionsModal.propTypes = {
  roomName: PropTypes.string,
  termsAndConditions: PropTypes.string,
};

export default TermsAndConditionsModal;
